<ng-container *ngIf="articlesWithVideo; else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="cell auto">

      <div class="bg-white">
        <div style="padding: 0 1rem;">
          <div class="hds-list collapsed">
            <div *ngFor="let article of articlesWithVideo">
              <app-widget-publication-article-item [article]="article"
                                                   [publicationUrl]="publicationUrl"
                                                   [accountId]="accountId"
                                                   [widgetName]="widget.widgetName"
                                                   [trackAction]="TRACK_ACTION_CLICK_LAST_VIDEO_ITEM">
              </app-widget-publication-article-item>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="card-footer">
    <a [href]="this.faTvUrl + '?accountId=' + this.accountId"
       target="_blank"
       class="button insito"
       (click)="onClickTrackActionFATV()">
      <span [title]="'news.actu.show-all-videos' | translate">
        {{'news.actu.show-all-videos' | translate}}</span>
    </a>
  </div>
</ng-container>

<ng-template #noData>
  <app-widget-message [message]="'news.actu.publication-not-working' | translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>
